import axios from "axios";
import { API_URLS } from "../config/api";

// Create axios instance for authentication
const authClient = axios.create({
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor for logging
authClient.interceptors.request.use(
  (config) => {
    console.log(
      `Auth API Request: ${config.method?.toUpperCase()} ${config.url}`
    );
    return config;
  },
  (error) => {
    console.error("Auth API Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
authClient.interceptors.response.use(
  (response) => {
    console.log(`Auth API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error(
      "Auth API Response Error:",
      error.response?.data || error.message
    );
    return Promise.reject(error);
  }
);

/**
 * Authentication API methods
 */
export const authAPI = {
  // Login user
  login: async (username, password, role) => {
    try {
      const response = await authClient.post(API_URLS.AUTH_LOGIN, {
        username,
        password,
        role,
      });

      if (response.data.success) {
        return {
          success: true,
          user: response.data.user,
        };
      } else {
        return {
          success: false,
          message: response.data.message || "Login failed",
        };
      }
    } catch (error) {
      console.error("Login API error:", error);

      if (error.response?.status === 401) {
        return {
          success: false,
          message: "Invalid username or password",
        };
      } else if (error.response?.data?.message) {
        return {
          success: false,
          message: error.response.data.message,
        };
      } else {
        return {
          success: false,
          message: "Network error. Please check your connection.",
        };
      }
    }
  },

  // Get all users (admin only)
  getUsers: async () => {
    try {
      const response = await authClient.get(API_URLS.USERS);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch users: ${error.message}`);
    }
  },
};

export default authAPI;
